"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../Constant");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: ", ";\n  height: 100%;\n  background-color: ", ";\n\n  @media (forced-colors: active) {\n    /* border required for Windows high contrast mode */\n    border: 3px solid Highlight;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  height: ", ";\n  background-color: ", ";\n  position: relative;\n  border-radius: ", ";\n  overflow: hidden;\n  /* border required for Windows high contrast mode */\n  border: 1px solid transparent;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Progress = _styledComponents.default.div(_templateObject(), function (props) {
  return "".concat(props.height, "px");
}, function (props) {
  return "".concat(props.backgroundColor);
}, function (props) {
  return "".concat(props.borderRadius, "px");
});

var Bar = _styledComponents.default.div(_templateObject2(), function (props) {
  return "".concat(props.value, "%");
}, function (props) {
  return "".concat(props.color);
});

var ProgressBar = function ProgressBar(_ref) {
  var backgroundColor = _ref.backgroundColor,
      borderRadius = _ref.borderRadius,
      height = _ref.height,
      color = _ref.color,
      value = _ref.value,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["backgroundColor", "borderRadius", "height", "color", "value"]);
  return /*#__PURE__*/_react.default.createElement(Progress, (0, _extends2.default)({
    "data-testid": "progress-bar",
    borderRadius: borderRadius,
    height: height,
    backgroundColor: backgroundColor
  }, rest), /*#__PURE__*/_react.default.createElement(Bar, {
    color: color,
    value: value
  }));
};

ProgressBar.propTypes = {
  backgroundColor: _propTypes.default.string,
  //Background color of progress bar
  borderRadius: _propTypes.default.number,
  //Defines the radii of the outer border edge
  color: _propTypes.default.string,
  //The color to render the progress bar
  height: _propTypes.default.number,
  //Total height of progress bar
  value: _propTypes.default.number //Width to render should be calculated externally

};
ProgressBar.defaultProps = {
  backgroundColor: "".concat(_Constant.Color.LIGHT_GREY),
  borderRadius: 3.5,
  color: "".concat(_Constant.Color.TEAL),
  height: 7,
  value: 0
};
var _default = ProgressBar;
exports.default = _default;